import React from 'react';

function SVGCoupon({
    width = 22,
    height = 22,
}: {
    width?: number;
    height?: number;
}) {
    return (
        <svg
            width={width}
            height={height}
            viewBox="0 0 22 22"
            fill="none"
            xmlns="http://www.w3.org/2000/svg">
            <path
                d="M1.83337 15.5833C1.83337 17.6084 3.475 19.25 5.50004 19.25H16.5C18.5251 19.25 20.1667 17.6084 20.1667 15.5833V14.6667C20.1667 14.1604 19.745 13.765 19.2666 13.5993C18.1899 13.2265 17.4167 12.2036 17.4167 11C17.4167 9.79644 18.1899 8.77346 19.2666 8.40067C19.745 8.23504 20.1667 7.83959 20.1667 7.33333V6.41667C20.1667 4.39162 18.5251 2.75 16.5 2.75H5.50004C3.475 2.75 1.83337 4.39162 1.83337 6.41667V7.33333C1.83337 7.83959 2.25504 8.23504 2.73344 8.40067C3.8102 8.77346 4.58337 9.79644 4.58337 11C4.58337 12.2036 3.8102 13.2265 2.73344 13.5993C2.25504 13.765 1.83337 14.1604 1.83337 14.6667V15.5833Z"
                stroke="#4D4D4D"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M9.16671 8.2487C9.16671 8.75496 8.7563 9.16536 8.25004 9.16536C7.74378 9.16536 7.33337 8.75496 7.33337 8.2487C7.33337 7.74244 7.74378 7.33203 8.25004 7.33203C8.7563 7.33203 9.16671 7.74244 9.16671 8.2487Z"
                fill="#4D4D4D"
            />
            <path
                d="M14.6667 13.7487C14.6667 14.255 14.2563 14.6654 13.75 14.6654C13.2438 14.6654 12.8334 14.255 12.8334 13.7487C12.8334 13.2424 13.2438 12.832 13.75 12.832C14.2563 12.832 14.6667 13.2424 14.6667 13.7487Z"
                fill="#4D4D4D"
            />
            <path
                d="M13.75 8.25L8.25003 13.75"
                stroke="#4D4D4D"
                strokeWidth="1.5"
                strokeLinecap="round"
            />
        </svg>
    );
}

export default SVGCoupon;
